<template>
  <v-chip
    small
    label
    outlined
    :color="statusColor(status)"
  >
    {{ statusLabel(status) }}
  </v-chip>
</template>

<script>
import { statusColor, statusLabel } from './monitoring'

export default {
  props: { status: { type: String, default: 'pending' } },
  methods: { statusColor, statusLabel }
}
</script>
